import './App.css';
import { useEffect, useState } from 'react';
import apps from './appsList';
import HomePage from './pages/HomePage';
import AppsPage from './pages/AppsPage';
import AppDetailPage from './pages/AppDetailPage';
import ContactPage from './pages/ContactPage';

const parseRoute = () => {
  const hash = window.location.hash || '#/';
  const path = hash.replace('#', '');
  const parts = path.split('/').filter(Boolean);

  if (parts[0] === 'app' && parts[1]) {
    return { page: 'app', slug: parts[1] };
  }
  if (parts[0] === 'apps') {
    return { page: 'apps' };
  }
  if (parts[0] === 'contact') {
    return { page: 'contact' };
  }
  return { page: 'home' };
};

function App() {
  const [route, setRoute] = useState(parseRoute());
  const activeApp = apps.find((app) => app.slug === route.slug);

  useEffect(() => {
    const handleHashChange = () => setRoute(parseRoute());
    window.addEventListener('hashchange', handleHashChange);
    if (!window.location.hash) {
      window.location.hash = '#/';
    }
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [route]);

  return (
    <div className="site">
      <nav className="site-nav">
        <a className="logo" href="#/">
          <img
            className="logo-icon"
            src={`${process.env.PUBLIC_URL}/LeanFactorLogo.png`}
            alt="LeanFactor logo"
          />
          <span>Lean Factor</span>
        </a>
        <div className="nav-links">
          <a className={route.page === 'home' ? 'active' : ''} href="#/">
            Studio
          </a>
          <a className={route.page === 'apps' ? 'active' : ''} href="#/apps">
            Apps
          </a>
          <a className={route.page === 'contact' ? 'active' : ''} href="#/contact">
            Contact
          </a>
        </div>
      </nav>

      <main>
        {route.page === 'home' && <HomePage />}
        {route.page === 'apps' && <AppsPage />}
        {route.page === 'app' && <AppDetailPage activeApp={activeApp} />}
        {route.page === 'contact' && <ContactPage />}
      </main>

      <footer className="site-footer">
        <span>© 2026 JellyBeanStudios @ 2026 Lean Factor. All rights reserved.</span>
        <span>Simple apps, simple life!</span>
      </footer>
    </div>
  );
}

export default App;
